import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAreAykhQ4sn0zwEFs8XCJ76_nNObUqkZc',
  authDomain: 'solids-control-app.firebaseapp.com',
  databaseURL: 'https://solids-control-app-default-rtdb.firebaseio.com',
  projectId: 'solids-control-app',
  storageBucket: 'solids-control-app.firebasestorage.app',
  messagingSenderId: '669619320749',
  appId: '1:669619320749:web:6ea1d2c8162d6659c45324',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);